import type { TRuleWithTheme } from '@/styles/theme';

export const container: TRuleWithTheme<{ size: number }> = ({ size, theme }) => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    width: `${size}px`,
    height: `${size}px`,
    borderRadius: '50%',
    overflow: 'hidden',
    userSelect: 'none',
    backgroundColor: theme.colors.lightGrey,
    color: theme.colors.foregroundsPrimary,
});

export const image: TRuleWithTheme = () => ({
    width: '100%',
    height: '100%',
    objectFit: 'cover',
});

export const initials: TRuleWithTheme<{ size: number }> = ({ size, theme }) => ({
    fontFamily: theme.fontFamily,
    fontSize: `${size * 0.4}px`,
    fontWeight: theme.typography.Headline3.fontWeight,
    lineHeight: 1,
    letterSpacing: 0,
    textTransform: 'uppercase',
});
